import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import {MdOutlineMenu,MdOutlineClose} from "react-icons/md";
import axios from 'axios'

import './navbar.css'
import LoadingProductos from "./LoadingProductos";

const Navbar = () => {
  // Toogle Menu
  const [MobileMenu, setMobileMenu] = useState(false);

  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const baseURL = "https://72jjtpdj.directus.app/items/categorias";
  const toggleClass = () => {
    window.scrollTo(0, 0);
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
};


function ScrollToTopOnMount() {
  useEffect(() => {
      window.scrollTo(0, 0);
  }, []);

  return null;
}

let boxClass = ["main-menu menu-right menuq1"];
if(isMenu) {
    boxClass.push('menuq2');
}else{
    boxClass.push('');
}


const [isMenuSubMenu, setMenuSubMenu] = useState(false);
      
const toggleSubmenu = () => {
  setMenuSubMenu(isMenuSubMenu === false ? true : false);
};

let boxClassSubMenu = ["sub__menus"];
if(isMenuSubMenu) {
    boxClassSubMenu.push('sub__menus__Active');
}else {
    boxClassSubMenu.push('');
}


React.useEffect(() => {
    axios.get(baseURL).then((response) => {

      setCategoryData(response.data.data);
    });

}, []);

  return (
    <>
      <header className="header">
        <div className="nav_container">


            <div className="header__middle__menus">
              <nav className="main-nav " >

                {/* Responsive Menu Button */}
                {isResponsiveclose === true ? <>
                  <span className="menubar__button" style={{ display: 'none' }} onClick={toggleClass} > <MdOutlineClose />   </span>
                </> : <>
                  <span className="menubar__button" style={{ display: 'none' }} onClick={toggleClass} > <MdOutlineMenu />   </span>
                </>}

                <ul className={boxClass.join(' ')}>
                  <li className="menu-item" >
                    <NavLink exact activeClassName='is-active' onClick={toggleClass} to={`/`}> Inicio </NavLink>
                  </li>
                  <li onClick={toggleSubmenu} className="menu-item sub__menus__arrows" > <Link to="#"> Categorías </Link>
                    <ul className={boxClassSubMenu.join(' ')} >
                      {
                        categoryData.length === 0 &&  <LoadingProductos/>
                      }
                      {
                        categoryData.map((category) => {
                          return (
                            <li key={category.id}><NavLink onClick={toggleClass} activeClassName='is-active' to={`/productview/${category.id}`}> {category.nombre} </NavLink>  </li> 
                           
                          )
                        })
                      }
                    </ul>
                  </li>
                  <li className="menu-item" ><NavLink onClick={toggleClass} activeClassName='is-active' to={`/armatupc`}> Arma tu PC </NavLink> </li>
                  <li className="menu-item" ><NavLink onClick={toggleClass} activeClassName='is-active' to={`/serviciotecnico`}> Servicio técnico </NavLink> </li>
                  <li className="menu-item" ><NavLink onClick={toggleClass} activeClassName='is-active' to={`/nosotros`}> Nosotros </NavLink> </li>
                </ul>
              </nav>
            </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
